var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('dv-scroll-board',{ref:"scrollBoard",staticStyle:{"width":"100%","height":"95%","font-size":"12px"},attrs:{"config":_vm.config},on:{"click":_vm.handleClick}}),_c('warningLoading',{ref:"warningLoading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }